<script lang="ts" setup>
import { LucideCheck } from 'lucide-vue-next'
import type { ICredit } from '~/components/entity/credit'

const props = defineProps<{
  credit: ICredit
}>()
</script>

<template>
  <ContentBlock
    v-if="props.credit && props.credit.purposes"
    :heading-text="$t('widget.credit_page.purposes.heading')"
    heading-class="h4"
    heading-tag="h2"
  >
    <div class="grid grid-cols-1 gap-2 md:grid-cols-3">
      <div v-for="item in props.credit.purposes" :key="item.id" class="flex gap-2">
        <LucideCheck class="min-w-5 text-blue-600" />
        <p>{{ item.title }}</p>
      </div>
    </div>
  </ContentBlock>
</template>
